import React from "react";
import {
	ServicesContainer,
	ServicesH1,
	ServicesWrapper,
	ServicesCard,
	ServicesIcon,
	ServiceIconLink,
	ServicesH2,
	ServiceP,
	ButtonContainer,
	LiveButton,
	CodeButton,
} from "./ServicesElements";

const Services = () => {
	return (
		<>
			<ServicesContainer id="mywork">
				<ServicesH1>What we do</ServicesH1>
				<ServicesWrapper>
					<ServicesCard>
						<ServiceIconLink>
							<ServicesIcon src={require("../../images/123.jpeg").default} />
						</ServiceIconLink>
						<ServicesH2>We collect caps</ServicesH2>
					</ServicesCard>
					<ServicesCard>
						<ServiceIconLink>
							<ServicesIcon src={require("../../images/2.jpeg").default} />
						</ServiceIconLink>
						<ServicesH2>We recycle them</ServicesH2>
					</ServicesCard>
					<ServicesCard>
						<ServiceIconLink>
							<ServicesIcon src={require("../../images/1.jpeg").default} />
						</ServiceIconLink>
						<ServicesH2>We make better world</ServicesH2>
					</ServicesCard>
				</ServicesWrapper>
			</ServicesContainer>
		</>
	);
};

export default Services;
